interface DefaultCellProps {
    value: string | number | null | undefined;
    minWidth?: number | null;
}

export default function CenterCell({ value, minWidth }: DefaultCellProps) {
    if (value === null || value === undefined || value === "") {
        return (
            <div
                className={`${!navigator.userAgent.includes("Safari") ? "min-w-max" : "whitespace-nowrap"} min-w-[100px] text-center`}
                style={{
                    minWidth: minWidth || 0,
                }}
            >
                -
            </div>
        );
    }

    return (
        <div
            className={`text-center`}
            style={{
                minWidth: minWidth || 0,
            }}
        >
            {String(value)}
        </div>
    );
}
